var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 22,
    height: 22,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(2.249 1.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_296",
    "data-name": "Trac\\xE9 296",
    d: "M22.093,5.609a1.035,1.035,0,0,1-.27.72.765.765,0,0,1-.63.27H15.8a.9.9,0,0,1-.9-.9V4.8H12.2v.9a.9.9,0,0,1-.9.9H5.944A.945.945,0,0,1,5,5.789a1.035,1.035,0,0,1,.27-.72A.765.765,0,0,1,5.9,4.8h4.5V3.9a.9.9,0,0,1,.9-.9h4.5a.9.9,0,0,1,.9.9v.9h4.453a.945.945,0,0,1,.945.81Z",
    transform: "translate(-4.999 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_297",
    "data-name": "Trac\\xE9 297",
    d: "M20.71,15.81,19.631,26.7H12.073L10.994,15.81a.9.9,0,0,0-.9-.81h0a.9.9,0,0,0-.9.99l1.17,11.7a.9.9,0,0,0,.9.81H20.44a.9.9,0,0,0,.9-.81l1.17-11.7a.9.9,0,0,0-.9-.99h0A.9.9,0,0,0,20.71,15.81Z",
    transform: "translate(-7.305 -9.602)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ed85c838c6cd77a0618dce24232f27b4.svg";
export { ForwardRef as ReactComponent };